import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
var Margin = function (props) {
    var _a = props.height, height = _a === void 0 ? "0" : _a, _b = props.mobileHeight, mobileHeight = _b === void 0 ? "0" : _b;
    return _jsx(Box, { sx: { height: { xs: "".concat(mobileHeight, "px"), lg: "".concat(height, "px") }, width: 1 } });
};
export default Margin;
